/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Invite_Code_DescriptionInputs */

const en_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an invite code to get 300 coins.`)
};

const ar_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل رمز دعوة لتحصل على 300 عملة.`)
};

const de_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib einen Einladungscode ein, um 300 Münzen zu erhalten.`)
};

const es_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un código de invitación para conseguir 300 monedas.`)
};

const fr_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un code d’invitation pour obtenir 300 pièces.`)
};

const it_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un codice invito per ottenere 300 monete.`)
};

const ja_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードを入力して300コインを獲得しましょう。`)
};

const ko_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드를 입력하고 코인 300개를 받아요.`)
};

const pt_br_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um código de convite para ganhar 300 moedas.`)
};

const ru_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите код приглашения, чтобы получить 300 монет.`)
};

const th_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอกรหัสเชิญเพื่อรับ 300 เหรียญ`)
};

const tr_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 jeton almak için bir davet kodu gir.`)
};

const zh_cn_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入邀请码即可获得 300 金币。`)
};

const zh_tw_enter_invite_code_description = /** @type {(inputs: Enter_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入邀請碼即可獲得 300 金幣。`)
};

/**
* | output |
* | --- |
* | "Enter an invite code to get 300 coins." |
*
* @param {Enter_Invite_Code_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const enter_invite_code_description = /** @type {((inputs?: Enter_Invite_Code_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Invite_Code_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enter_invite_code_description(inputs)
	if (locale === "ar") return ar_enter_invite_code_description(inputs)
	if (locale === "de") return de_enter_invite_code_description(inputs)
	if (locale === "es") return es_enter_invite_code_description(inputs)
	if (locale === "fr") return fr_enter_invite_code_description(inputs)
	if (locale === "it") return it_enter_invite_code_description(inputs)
	if (locale === "ja") return ja_enter_invite_code_description(inputs)
	if (locale === "ko") return ko_enter_invite_code_description(inputs)
	if (locale === "pt_br") return pt_br_enter_invite_code_description(inputs)
	if (locale === "ru") return ru_enter_invite_code_description(inputs)
	if (locale === "th") return th_enter_invite_code_description(inputs)
	if (locale === "tr") return tr_enter_invite_code_description(inputs)
	if (locale === "zh_cn") return zh_cn_enter_invite_code_description(inputs)
	return zh_tw_enter_invite_code_description(inputs)
});